import React from "react";
import formats from './ToolbarOptions.js';

const renderOptions = (formatData, key) => {
    const { className, options } = formatData;

    return (
        <select key={key} className={className} defaultValue="">
            <option value=""></option>
            {options.map((value, idx) => (
                <option key={value || idx} value={value}></option>
            ))}
        </select>
    );
};

const renderSingle = (formatData, key) => {
    const { className, value } = formatData;

    return (
        <button
            key={key}
            className={className}
            value={value}
            type="button"
        ></button>
    );
};

const CustomToolbar = () => (
    <div id="toolbar">
        {formats.map((classes, i) => (
            <span key={`group-${i}`} className="ql-formats">
                {classes.map((formatData, j) =>
                    formatData.options
                        ? renderOptions(formatData, `format-${i}-${j}`)
                        : renderSingle(formatData, `format-${i}-${j}`)
                )}
            </span>
        ))}
    </div>
);

export default CustomToolbar;
